/* eslint-disable indent */
/* eslint-disable camelcase */
/* eslint-disable max-statements */
// Libraries
import { getTagsValue } from '../../utils/helperMethods';
import { FormElems, Alert, GetTemplateFields } from '../';
import { validityOptions } from '../../utils/constants/commonValues';
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';
import {
    createPayLinksRequest,
    createPayLinksError,
} from '../../containers/PaymentLink/redux/paymentLink.actions';
import validate from './validator';
import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, reduxForm, change } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';

//  Components

// Utils

// Actions

// Validator

// Styles
import './createPaymentLink.scss';
import { fieldLevelValidators } from 'utils/validators';

// Check the sharable flag status.
const getShareableValue = value => {
    if (value === true || value === 'shareValue') {
        return true;
    } else if (Array.isArray(value) && value.includes('shareValue')) {
        return true;
    }
    return false;
};

/**
 * CreatePaymentLink Component
 *
 * @param {Object} props - React component props
 */

const CreatePaymentLink = props => {
    const {
        handleSubmit,
        actions,
        closePopup,
        formData={},
        paymentLinkData,
        fetchData,
        resetPage,
    } = props;

    const { values } = formData;

    const isMultiProductLink =
        values &&
        values.multiProductLink &&
        values.multiProductLink.length &&
        values.multiProductLink.includes('multiProductLink');

    const { createPay, templateDetails } = paymentLinkData;

    const { template } = templateDetails;

    // template specific checks
    const isMultiProductLinkHidden =
        template && template.multiProductLinkHidden;

    const isDefaultShareEnabled = template && template.defaultShareEnabled;

    const defaultLinkName = template && template.defaultLinkName;

    // useEffect to update the default value of link ID
    useEffect(() => {
        if (defaultLinkName) {
            actions.change('create-payment-link', 'linkName', defaultLinkName);
        }
    }, [defaultLinkName]);

    // useEffect to update the default value of share value
    useEffect(() => {
        if (isDefaultShareEnabled) {
            actions.change('create-payment-link', 'shareValue', ['shareValue']);
        }
    }, [isDefaultShareEnabled]);

    // Handle on Success of Create PayLink
    useEffect(() => {
        if (createPay.isSuccess) {
            closePopup();
            fetchData({ pageIndex: 1, pageSize: 10 });
            resetPage();
            toast.info(SUCCESS_MESSAGES.CREATE_ENTITY('Paylink'));
        }
        return () => {
            actions.createPayLinksError({ error: {} });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchData, createPay.isSuccess]);

    // Handle Form submit
    function handleFormSubmit(data) {
        const reqPayload = {
            amount: parseFloat(data.amount),
            linkId: data.linkId,
            linkName: data.linkName,
            remarks: data.remarks,
            validityPeriod: parseInt(data.validity, 10),
        };

        // sending template data if the template is enabled for the merchant
        if (template?.templateId) {
            reqPayload.templateInfo = data.templateInfo
                ? data.templateInfo
                : { additionalInfo: {} };
            reqPayload.templateInfo.templateId = template?.templateId;

            const filteredFields = template.fields.filter(item => item.type !== 'placeholder');
            const hiddenFields = filteredFields.filter(item => item.type === 'hidden');

            if (hiddenFields && hiddenFields.length) {
                hiddenFields.forEach(item => {
                    reqPayload.templateInfo.additionalInfo[item.name] =
                        item.defaultValue;
                });
            }
        }

        if (isMultiProductLink) {
            const { productInfo } = data;

            let mandatorySum = 0;
            let totalSum = 0;
            const updatedProductInfo = productInfo.map(
                (product, productIndex) => {
                    totalSum = totalSum + Number(product.amount);
                    if (
                        product.isMandatory &&
                        product.isMandatory.length &&
                        product.isMandatory.includes('isMandatory')
                    ) {
                        mandatorySum = mandatorySum + Number(product.amount);
                    }
                    return {
                        ...product,
                        isMandatory:
                            product.isMandatory &&
                            product.isMandatory.length &&
                            product.isMandatory.includes('isMandatory')
                                ? true
                                : false,
                    };
                }
            );

            reqPayload.maxAmount = totalSum;
            reqPayload.minAmount = mandatorySum;
            reqPayload.productInfo = updatedProductInfo;
            reqPayload.amount = mandatorySum;

            if (mandatorySum <= 0) {
                toast.error('One Non Zero product should be Mandatory');
                return;
            }
        } else {
            reqPayload.maxAmount = reqPayload.amount;
            reqPayload.minAmount = reqPayload.amount;
        }

        if (!isEmpty(data.shareValue)) {
            reqPayload.communicationDetails = {
                email:
                    data.sharebyemail &&
                    getTagsValue(JSON.parse(data.sharebyemail)),
                mobile:
                    data.sharebysms &&
                    getTagsValue(JSON.parse(data.sharebysms)),
            };
        }
        console.log("requested payload", reqPayload);
        actions.createPayLinksRequest(reqPayload);
    }

    // Get the isSharable checkbox value;
    const isShareable = useMemo(
        () => getShareableValue(formData.values && formData.values.shareValue),
        [formData.values]
    );

    useEffect(() => {
        const isValidNumber = value =>
            typeof value === 'number' && !isNaN(value);

        if (
            isMultiProductLink &&
            values.productInfo &&
            values.productInfo.length
        ) {
            let sum = 0;

            values.productInfo.forEach((item, index) => {
                let numberToBeAdded = item?.amount ? item?.amount : 0;
                numberToBeAdded = Number(numberToBeAdded);
                numberToBeAdded = isValidNumber(numberToBeAdded)
                    ? numberToBeAdded
                    : 0;

                sum = sum + numberToBeAdded;

                actions.change('create-payment-link', 'amount', sum);
            });
        }
    }, [values?.productInfo]);

    useEffect(() => {
        actions.change('create-payment-link', 'amount', null);
        actions.change('create-payment-link', 'productInfo', null);
    }, [values?.multiProductLink]);

    return (
        <form
            className="create-payment-link"
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Link Name</p>
                    <Field
                        name="linkName"
                        type="text"
                        component={FormElems.Input}
                        disabled={defaultLinkName}
                        placeholder="Enter Link Name"
                        pattern={/^[A-Za-z0-9]+$/}
                    />
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Link Id</p>
                    <Field
                        name="linkId"
                        type="text"
                        component={FormElems.Input}
                        placeholder="Enter Link Id"
                        pattern={/^[A-Za-z0-9]+$/}
                    />
                </div>
            </div>
            {!isMultiProductLinkHidden ? (
                <div className="form-section shareSection">
                    <div className="form-field">
                        <Field
                            name="multiProductLink"
                            options={[
                                {
                                    label: 'Multiple Product Payment',
                                    value: 'multiProductLink',
                                    checked: false,
                                },
                            ]}
                            valueField="value"
                            labelField="label"
                            component={FormElems.Checkbox}
                        />
                    </div>
                </div>
            ) : (
                <></>
            )}
            {isMultiProductLink ? (
                <div className="form-section">
                    <FieldArray
                        name="productInfo"
                        component={multiProductDownLink}
                    />
                </div>
            ) : (
                <></>
            )}

            {template && template.templateId ? (
                <>
                    <GetTemplateFields
                        templateId={template.templateId}
                        templateFields={template.fields.filter(
                            item =>
                                item.name !== 'feeType' && item.type != 'hidden' && item.type !== 'placeholder'
                        )}
                        isMultiProductLink={isMultiProductLink}
                    />
                    <div className="form-section viewOnly border-b" />
                    <>
                        <div className="form-section multiCol">
                            {template.fields
                                .filter(
                                    item =>
                                        item.type !== 'placeholder' &&
                                        item.name === 'feeType' &&
                                        item.type != 'hidden'
                                )
                                .map((field, fieldIndex) => {
                                    const {
                                        name,
                                        label,
                                        type,
                                        maxLength,
                                        placeholder,
                                        max,
                                        min,
                                        validators,
                                    } = field;

                                    // Map validators to corresponding functions
                                    const validationRule = validators
                                        .map(
                                            validator =>
                                                fieldLevelValidators[validator]
                                        )
                                        .filter(
                                            validatorFunction =>
                                                validatorFunction !==
                                                    undefined &&
                                                validatorFunction !== null
                                        );

                                    return (
                                        <div
                                            className="form-field"
                                            key={`form-field-feeType-${fieldIndex}`}
                                        >
                                            {/* Display label */}
                                            <p className="label">{label}</p>

                                            {/* Render input field */}
                                            <Field
                                                name={`templateInfo.additionalInfo.${name}`}
                                                id={`templateInfo.additionalInfo.${name}`}
                                                type={type}
                                                component={FormElems.Input}
                                                placeholder={placeholder}
                                                max={max}
                                                min={min}
                                                maxLength={maxLength}
                                                validate={
                                                    validationRule
                                                        ? validationRule
                                                        : []
                                                }
                                            />
                                        </div>
                                    );
                                })}
                            <div className="form-field">
                                <p className="label">Amount</p>
                                <Field
                                    name="amount"
                                    id="amount"
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="Enter Amount"
                                    disabled={isMultiProductLink}
                                />
                            </div>
                        </div>
                        <div className="form-section multiCol">
                            <div className="form-field">
                                <p className="label">Validity</p>
                                <Field
                                    name="validity"
                                    placeholder="Enter Days"
                                    data={validityOptions || []}
                                    labelField="name"
                                    valueField="value"
                                    component={FormElems.Select}
                                    label="Enter Days"
                                />
                            </div>
                        </div>
                    </>
                </>
            ) : (
                <div className="form-section multiCol">
                    <div className="form-field">
                        <p className="label">Amount</p>
                        <Field
                            name="amount"
                            id="amount"
                            type="number"
                            component={FormElems.Input}
                            placeholder="Enter Amount"
                            disabled={isMultiProductLink}
                        />
                    </div>
                    <div className="form-field">
                        <p className="label">Validity</p>
                        <Field
                            name="validity"
                            placeholder="Enter Days"
                            data={validityOptions || []}
                            labelField="name"
                            valueField="value"
                            component={FormElems.Select}
                            label="Enter Days"
                        />
                    </div>
                </div>
            )}

            <div className="form-section comment-section">
                <div className="form-field">
                    <p className="label">Remarks</p>
                    <Field
                        wrapperClass="comment-input"
                        name="remarks"
                        type="textarea"
                        isDisabled={false}
                        component={FormElems.TextArea}
                        placeholder="Enter Comment"
                    />
                </div>
            </div>
            <div className="form-section shareSection">
                <div className="form-field">
                    <Field
                        name="shareValue"
                        options={[
                            {
                                label: 'Do you want to Share ?',
                                value: 'shareValue',
                                checked: false,
                            },
                        ]}
                        valueField="value"
                        labelField="label"
                        component={FormElems.Checkbox}
                    />
                </div>
            </div>
            {isShareable ? (
                <>
                    <div className="form-section">
                        <div className="form-field">
                            <p className="label">Share by SMS</p>
                            <Field
                                name="sharebysms"
                                component={FormElems.InputTags}
                                placeholder="Enter Mobile"
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <div className="form-field">
                            <p className="label">Share by Email</p>
                            <Field
                                name="sharebyemail"
                                component={FormElems.InputTags}
                                placeholder="Enter Email ID"
                            />
                        </div>
                    </div>
                </>
            ) : null}
            {createPay.error && createPay.error.errorMessage ? (
                <Alert>{createPay.error.errorMessage}</Alert>
            ) : null}
            <div className="form-section action">
                <div className="cancel-btn" onClick={() => closePopup()}>
                    CANCEL
                </div>
                <FormElems.Button
                    buttonType="primary"
                    isDisable={formData && isEmpty(formData.values)}
                    text="SUBMIT"
                />
            </div>
        </form>
    );
};

const multiProductDownLink = ({
    fields,
    meta: { error, submitFailed },
    auth,
    isViewMode,
}) => {
    const newAddFieldInitialData = { isMandatory: ['isMandatory'] };
    if (fields.length <= 0) {
        fields.push({ ...newAddFieldInitialData });
    }

    return (
        <div className="col-section">
            <div className="register-section">
                {fields.map((item, index) => (
                    <>
                        <div className="form-section multiCol product-section">
                            {!isViewMode && (
                                <FormElems.Button
                                    type="button"
                                    buttonType="secondary"
                                    id={`removeNumber-${index}`}
                                    customClass="btn-remove"
                                    handleClick={() => fields.remove(index)}
                                />
                            )}
                            <div className="form-field">
                                <p className="label">Product Name</p>
                                <Field
                                    name={`${item}.name`}
                                    id={`${item}.name`}
                                    type="text"
                                    component={FormElems.Input}
                                    placeholder="Enter Name"
                                    disabled={isViewMode}
                                    pattern={/^[A-Za-z0-9]+$/}
                                />
                            </div>
                            <div className="form-field">
                                <p className="label">Amount</p>
                                <Field
                                    name={`${item}.amount`}
                                    id={`${item}.amount`}
                                    type="number"
                                    min={0}
                                    component={FormElems.Input}
                                    placeholder="Enter Amount"
                                    disabled={isViewMode}
                                />
                            </div>
                            <div className="form-field product-section-checkbox">
                                <Field
                                    name={`${item}.isMandatory`}
                                    id={`${item}.isMandatory`}
                                    options={[
                                        {
                                            label: 'Mandatory',
                                            value: 'isMandatory',
                                            checked: false,
                                        },
                                    ]}
                                    valueField="value"
                                    labelField="label"
                                    component={FormElems.Checkbox}
                                />
                            </div>
                        </div>
                    </>
                ))}
            </div>
            <div className="section-title">
                {!isViewMode && (
                    <FormElems.Button
                        type="button"
                        buttonType="secondary"
                        id="add-product"
                        text={`+ Add Product`}
                        customClass="btn-small"
                        handleClick={() => {
                            fields.push({ ...newAddFieldInitialData });
                        }}
                    />
                )}
            </div>
        </div>
    );
};

const mapStateToProps = ({ auth, paymentLinkData, form }) => ({
    auth,
    paymentLinkData,
    formData: form['create-payment-link'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            createPayLinksRequest,
            createPayLinksError,
            change,
        },
        dispatch
    ),
});

multiProductDownLink.propTypes = {
    fields: PropTypes.object,
    meta: PropTypes.object,
    auth: PropTypes.object,
    uniqueId: PropTypes.object,
    isViewMode: PropTypes.bool,
};

CreatePaymentLink.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    closePopup: PropTypes.func,
    handleSubmit: PropTypes.func,
    paymentLinkData: PropTypes.object,
    formData: PropTypes.object,
    fetchData: PropTypes.object,
    resetPage: PropTypes.func,
};

export default compose(
    reduxForm({
        form: 'create-payment-link',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(CreatePaymentLink);
